import { ReduxState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {CompetitionNavState} The Stats Leaders state.
 */
export const navSelector = (state) => state.competitionNavV2;
